import { useState } from 'react';
import { Button, Input } from '@asigna/kit';
import { ModalCloseButton } from 'components';

interface Props {
  onClose: () => void;
  onSuccess: (name: string) => void;
}

export const SubAccountCreateDialog = (props: Props) => {
  const [name, setName] = useState('');
  const { onClose, onSuccess } = props;

  return (
    <div className="flex flex-col gap-16 relative p-4">
      <div className="flex items-center justify-between mb-8">
        <p className="text-r20">Create Sub-Account</p>
        <ModalCloseButton onClick={onClose} />
      </div>

      <div className="flex flex-col gap-32">
        <div className="flex flex-col gap-8">
          <p className="text-r14">Name</p>
          <Input
            onChange={(e) => {
              setName((e.target as HTMLInputElement).value);
            }}
            placeholder="Name..."
            value={name}
          />
        </div>

        <Button
          disabled={!name}
          onClick={() => onSuccess(name)}
          message="Save"
          fullWidth
          colorType="primary"
        />
      </div>
    </div>
  );
};
